<template>
  <div class="cms-image-block">
    <div v-if="hasImage" class="cms-image-content" v-html="block.bodyContent"></div>
    <div v-else class="cms-image-placeholder">
      <span class="cms-image-icon" aria-hidden="true">🖼</span>
      <p class="cms-image-placeholder-title">{{ block.title || '图片区块' }}</p>
    </div>
    <p v-if="block.subtitle" class="cms-image-caption">{{ block.subtitle }}</p>
  </div>
</template>

<script>
export default {
  name: 'ImageBlock',
  props: {
    block: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasImage() {
      return /<img[\s>]/i.test(this.block.bodyContent || '')
    }
  }
}
</script>

<style scoped>
.cms-image-block {
  width: 100%;
}

.cms-image-content >>> img {
  display: block;
  max-width: 100%;
  height: auto;
  border-radius: var(--front-radius);
}

.cms-image-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 180px;
  padding: 24px;
  background: #eef2f6;
  border-radius: var(--front-radius);
  text-align: center;
}

.cms-image-icon {
  font-size: 36px;
  line-height: 1;
  margin-bottom: 10px;
  opacity: 0.55;
}

.cms-image-placeholder-title {
  margin: 0;
  color: var(--subtle);
  font-size: 14px;
}

.cms-image-caption {
  margin: 10px 0 0;
  color: var(--subtle);
  font-size: 13px;
  line-height: 1.6;
  text-align: center;
}
</style>
